import { Plane } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted/30 py-8">
      <div className="container flex flex-col items-center justify-between gap-4 md:flex-row">
        <div className="flex items-center gap-2 font-display text-lg font-bold text-primary">
          <Plane className="h-5 w-5 text-accent" />
          <span>TripDoc</span>
        </div>
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} TripDoc. Transform your trips into professional itineraries.
        </p>
      </div>
    </footer>
  );
}
